import { Col, Row, Typography } from "antd";
import { Formik } from "formik";
import * as Yup from "yup";
import { Checkbox, Form, FormItem } from "formik-antd";
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
  FormikDate,
  FormikInput,
  FormikSubmitButton,
  FormikSelect,
  FormikTextArea,
  FormikT24Select,
} from "../FormItems/index";
import FileUpload from "../Utilities/FileUpload";
import requirementType from "../../data/requirementType.json";
import * as clientReducer from "../Redux/client/reducer";
import moment from "moment";
import { Helmet } from "react-helmet";
import ClientProfileCompletion from "./Profile/ClientProfileCompletion";

const initialValues = {
  jobTitle: "",
  T24Profile: "",
  requirementType: "",
  targetStartDate: "",
  targetEndDate: "",
  endDateFlexible: false,
  additionalComments: "",
  fileIds: "",
};

const validationSchema = Yup.object({
  jobTitle: Yup.string().required("Job Title is required"),
  T24Profile: Yup.string().required("T24 profile is required"),
  requirementType: Yup.string().required("Select the requirement type"),
  targetStartDate: Yup.date()
    .required()
    .typeError("Start Date is Required")
    .min(
      moment(new Date()).format("YYYY/MM/DD"),
      "Start Date should be greater than today"
    ),
  targetEndDate: Yup.date()
    .required()
    .typeError("End Date is required")
    .min(
      Yup.ref("targetStartDate"),
      "End Date should be greater than Start date"
    ),
});

const NewJobForm = (props) => {
  const { fetchProfiles } = props;
  const { allT24Profiles } = useSelector((state) => state.clientStore);
  const dateFormat = (date) => moment(date).format("YYYY-MM-DD");
  const createJob = (jobDetails) => {
    jobDetails.fileIds = props.fileIds;
    jobDetails.targetStartDate = dateFormat(jobDetails.targetStartDate);
    jobDetails.targetEndDate = dateFormat(jobDetails.targetEndDate);
    props.createJob(jobDetails);
  };
  const unload = (e) => {
    e.preventDefault();
    return (e.returnValue = "Are you Sure ?");
  };
  useEffect(() => {
    window.addEventListener("beforeunload", unload);
    return () => window.removeEventListener("beforeunload", (e) => unload);
  });
  useEffect(() => {
    const fetchingAllProfiles = async () => {
      await fetchProfiles();
    };
    fetchingAllProfiles();
  }, [fetchProfiles]);
  return (
    <Col style={{ overflowX: "hidden" }}>
      <Helmet title="New Job | Unicon" />
      <ClientProfileCompletion />
      <Col
        xs={{ span: 22 }}
        md={{ span: 20 }}
        lg={{ span: 20 }}
        xl={{ span: 16 }}
        xxl={{ span: 16 }}
        style={{ margin: "auto", marginTop: "2vh" }}
      >
        <Formik
          initialValues={initialValues}
          validateOnMount
          validationSchema={validationSchema}
          onSubmit={createJob}
        >
          {(formik) => {
            return (
              <Form>
                <Row justify="space-between">
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <Typography.Title level={4}>
                      Create a new job
                    </Typography.Title>
                  </Col>
                  <Col xs={{ span: 0 }} md={{ span: 6 }}>
                    <FormikSubmitButton
                      id="submit-createJob"
                      disabled={!formik.isValid}
                      name="Create Job"
                    ></FormikSubmitButton>
                  </Col>
                </Row>
                <Row style={{ marginTop: "2vh" }} justify="space-between">
                  <Col xl={{ span: 10 }} md={{ span: 12 }} xs={{ span: 24 }}>
                    <FormikInput
                      id="jobTitle"
                      name="jobTitle"
                      label="Job Title"
                      placeholder="Enter Job Title"
                    />
                  </Col>
                  <Col xl={{ span: 11 }} md={{ span: 10 }} xs={{ span: 24 }}>
                    <FormikT24Select
                      id="selectT24Release"
                      label="T24 Profile"
                      name="T24Profile"
                      placeholder="Select T24 Profile"
                      options={allT24Profiles}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "2vh" }} justify="space-between">
                  <Col xl={{ span: 10 }} md={{ span: 8 }} xs={{ span: 24 }}>
                    <FormikSelect
                      id="selectRequirementType"
                      name="requirementType"
                      label="Requirement Type"
                      options={requirementType}
                      callBack={false}
                      placeholder="Select Requirement Type"
                    />
                  </Col>
                  <Col
                    xl={{ span: 5, offset: 2 }}
                    md={{ span: 6 }}
                    xs={{ span: 24 }}
                  >
                    <FormikDate
                      id="startDate"
                      name="targetStartDate"
                      label="Start Date"
                      placeholder="Select Start Date"
                    />
                  </Col>
                  <Col xl={{ span: 5 }} md={{ span: 6 }} xs={{ span: 24 }}>
                    <FormikDate
                      id="endDate"
                      name="targetEndDate"
                      label="End Date"
                      placeholder="Select End Date"
                    />
                    <Row>
                      <FormItem name="endDateFlexible">
                        <Checkbox
                          name="endDateFlexible"
                          data-testid="endDateFlexible"
                        >
                          End Date Flexible
                        </Checkbox>
                      </FormItem>
                    </Row>
                  </Col>
                </Row>
                <Row justify="space-between">
                  <Col xl={{ span: 10 }} md={{ span: 10 }} xs={{ span: 24 }}>
                    <FileUpload id="fileUpload" name="fileIds" />
                  </Col>
                  <Col xl={{ span: 11 }} md={{ span: 12 }} xs={{ span: 24 }}>
                    <FormikTextArea
                      id="additionalComments"
                      label="Additional Comments"
                      name="additionalComments"
                    />
                  </Col>
                </Row>
                <Col xs={{ span: 24 }} sm={{ span: 0 }}>
                  <FormikSubmitButton
                    id="submit-createJob"
                    disabled={!formik.isValid}
                    name="Create Job"
                  ></FormikSubmitButton>
                </Col>
              </Form>
            );
          }}
        </Formik>
      </Col>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  fileIds: state.userStore.uploadedFiles,
});

const mapDispatchToProps = (dispatch) => {
  return {
    createJob: (jobDetails) => dispatch(clientReducer.createJob(jobDetails)),
    fetchProfiles: () => dispatch(clientReducer.getAllProfiles()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewJobForm);
